export class TypeaheadClass {
  constructor (templateVariables, setModelValue, otherHandler) {
    this.originalTypeaheadValue = ''
    this.templateVariables = templateVariables
    this.setModelValue = setModelValue
    this.otherHandler = otherHandler
    this.cursorContext = {}
  }

  getMatches (value) {
    // Skip if cursor context is not initialized or outside of a template
    if (!this.cursorContext || this.cursorContext.invalid) return

    const ctxValue = this.cursorContext.value

    // If context value is not a string (not initialized yet), exit.
    // Empty string is allowed: in this case we show all variables.
    if (typeof ctxValue !== 'string') return

    const search = ctxValue.toLowerCase()

    // Keep the last raw value for compatibility with older helpers;
    // fall back to full text from cursorContext when value is not provided.
    this.originalTypeaheadValue =
      (typeof value === 'string' ? value : this.cursorContext.text) || ''

    if (!Array.isArray(this.templateVariables) || !this.templateVariables.length) return

    return this.templateVariables.filter((item) =>
      typeof item === 'string' && item.toLocaleLowerCase().includes(search)
    )
  }

  onSelect (item, model, otherHandlerData) {
    const newValue = this.cursorContext.text.slice(0, this.cursorContext.startIndex) + item + this.cursorContext.text.slice(this.cursorContext.startIndex + this.cursorContext.value.length)
    this.setModelValue(newValue, otherHandlerData)
    otherHandlerData && this.otherHandler(otherHandlerData)
  }
}

export function getMatches (value, vm) {
  vm.originalTypeaheadValue = value
  if (!value.includes('{{')) return

  return vm.templateVariables
}

export function typeaheadOnSelect (item, vm, setModelValue) {
  const currentValue = vm.originalTypeaheadValue || ''
  let newValue = currentValue

  const fullTemplateMatch = currentValue.match(/{{[^{}]*}}/)
  if (fullTemplateMatch) {
    newValue = currentValue.replace(/{{[^{}]*}}/, `{{${item}}}`)
  } else {
    const openTemplateMatch = currentValue.match(/{{[^{}]*$/)
    if (openTemplateMatch) {
      newValue = currentValue.replace(/{{[^{}]*$/, `{{${item}}}`)
    } else {
      newValue = currentValue + item
    }
  }
  setModelValue(newValue)
}

export function highlightClass (vm, model) {
  if (!vm.templateVariables?.length || !model?.includes('{{')) return
  return vm.templateVariables?.some(item => model.includes(item))
}

export function highlightClassSimple (arr, model) {
  if (!(arr?.length && model?.includes('{{') && model?.includes('}}'))) return

  const re = /{+\s*([^{}]*?)\s*}+/
  const variable = model.match(re)?.[1]
  return variable && arr?.includes(variable)
}
